import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { memo } from 'react';

type ItemsType = {
  id: UniqueIdentifier;
  data: any;
  columnData?: any;
  render?: (data: any, columnData: any) => React.ReactNode;
  disabled?: boolean;
};

const Items = (props: ItemsType) => {
  //#region Destructuring Props
  //#endregion Destructuring Props

  //#region Declare Hook
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.id,
    data: {
      type: 'item',
    },
    disabled: !!props?.disabled,
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
      }}
      className={clsx(' w-full', 'select-none', isDragging && 'opacity-50')}
      {...listeners}
    >
      {props?.render ? props?.render(props?.data, props?.columnData) : props.data.name}
    </Box>
  );
};

export default memo(Items);
